import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE } from '../services/api';

const fmt  = n => '$' + Number(n || 0).toLocaleString('es-CO');
const fmtF = d => { try { return new Date(d).toLocaleDateString('es-CO', { timeZone: 'America/Bogota' }); } catch { return ''; } };

const EVENTOS = {
  '030': { nombre: 'Acuse de Recibo',            colorBase: '#0369a1', colorDone: '#0ea5e9', bg: '#eff6ff', emoji: '📬', cliente: true  },
  '032': { nombre: 'Recibo del Bien / Servicio',  colorBase: '#047857', colorDone: '#10b981', bg: '#f0fdf4', emoji: '📦', cliente: true  },
  '033': { nombre: 'Aceptación Expresa',          colorBase: '#7c3aed', colorDone: '#8b5cf6', bg: '#faf5ff', emoji: '🤝', cliente: true  },
  '031': { nombre: 'Reclamo',                     colorBase: '#b45309', colorDone: '#f59e0b', bg: '#fffbeb', emoji: '⚠️', cliente: true  },
  '034': { nombre: 'Aceptación Tácita',           colorBase: '#475569', colorDone: '#64748b', bg: '#f8fafc', emoji: '⏱️', cliente: false },
};

const MOTIVOS_031 = [
  { codigo: '01', desc: 'Documento con defectos de forma' },
  { codigo: '02', desc: 'Retención en la fuente' },
  { codigo: '03', desc: 'Descuento comercial o pronto pago' },
  { codigo: '04', desc: 'Devolución de mercancía' },
  { codigo: '05', desc: 'Otro' },
];

// Orden de pasos según flujo DIAN (034 solo informativo)
const PASOS = ['030', '032', '033', '031', '034'];

export default function FacturaRadianPublica() {
  const { token } = useParams();
  const [data,   setData]   = useState(null);
  const [loading,setLoading]= useState(true);
  const [error,  setError]  = useState('');
  const [accion, setAccion] = useState(null);
  const [form,   setForm]   = useState({ nombre_firmante: '', motivo_codigo: '01', motivo_desc: '' });
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState(null);

  const reload = () =>
    fetch(`${API_BASE}/api/factura-radian/${token}`).then(r => r.json()).then(d => { if (!d.error) setData(d); }).catch(() => {});

  useEffect(() => {
    fetch(`${API_BASE}/api/factura-radian/${token}`)
      .then(r => r.json())
      .then(d => { if (d.error) setError(d.error); else setData(d); })
      .catch(() => setError('No se pudo cargar la factura'))
      .finally(() => setLoading(false));
  }, [token]);

  const codigosRegistrados = (data?.eventos || []).map(e => e.evento_codigo);
  const tiene030 = codigosRegistrados.includes('030');

  const puedeRegistrar = cod => {
    if (codigosRegistrados.includes(cod)) return false;
    if (['031','032','033'].includes(cod) && !tiene030) return false;
    return true;
  };

  const handleRegistrar = async () => {
    if (!accion) return;
    if (!form.nombre_firmante.trim()) return alert('Ingrese su nombre completo');
    if (accion === '031' && !form.motivo_desc.trim()) return alert('Indique el motivo del reclamo');
    setSaving(true);
    try {
      const res  = await fetch(`${API_BASE}/api/factura-radian/${token}/evento`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          codigo:          accion,
          nombre_firmante: form.nombre_firmante,
          motivo_codigo:   accion === '031' ? form.motivo_codigo : undefined,
          motivo_desc:     accion === '031' ? form.motivo_desc   : undefined,
        }),
      });
      const json = await res.json();
      if (json.ok) {
        setResult({ ok: true, mensaje: `"${EVENTOS[accion].nombre}" registrado correctamente.` });
        setAccion(null);
        setForm({ nombre_firmante: '', motivo_codigo: '01', motivo_desc: '' });
        reload();
      } else {
        setResult({ ok: false, mensaje: json.error || 'Error al registrar' });
      }
    } catch { setResult({ ok: false, mensaje: 'Error de conexión' }); }
    finally { setSaving(false); }
  };

  if (loading) return (
    <div style={s.page}>
      <div style={s.loadBox}>
        <div style={s.spinner} />
        <p style={{ color:'#64748b', marginTop:16, textAlign:'center' }}>Cargando factura…</p>
      </div>
    </div>
  );

  if (error) return (
    <div style={s.page}>
      <div style={{ ...s.loadBox, textAlign:'center' }}>
        <div style={{ fontSize:48 }}>❌</div>
        <h2 style={{ color:'#ef4444', margin:'12px 0 6px' }}>Factura no encontrada</h2>
        <p style={{ color:'#64748b' }}>{error}</p>
      </div>
    </div>
  );

  const f = data;

  return (
    <div style={s.page}>

      {/* ── Encabezado empresa ── */}
      <div style={s.header}>
        {f.empresa_logo_url && (
          <img
            src={/^https?:\/\//.test(f.empresa_logo_url) ? f.empresa_logo_url : `${API_BASE}${f.empresa_logo_url}`}
            alt="Logo"
            style={{ height:48, objectFit:'contain', marginBottom:8 }} />
        )}
        <div style={s.headerNombre}>{f.empresa_nombre}</div>
        <div style={s.headerSub}>NIT: {f.empresa_nit}</div>
        {f.empresa_direccion && (
          <div style={s.headerSub}>{f.empresa_direccion}{f.empresa_ciudad ? ', ' + f.empresa_ciudad : ''}</div>
        )}
      </div>

      {/* ── Botones de acción RADIAN (entre header e invoice) ── */}
      <div style={s.botonesWrap}>
        {PASOS.map(cod => {
          const ev         = EVENTOS[cod];
          const registrado = codigosRegistrados.includes(cod);
          const disponible = puedeRegistrar(cod);
          const activo     = accion === cod;
          const esTacita   = cod === '034';

          // Para 034: calcular días restantes desde el 030
          let tacitaInfo = null;
          if (esTacita && !registrado) {
            const ev030 = (data?.eventos || []).find(e => e.evento_codigo === '030');
            if (ev030) {
              const fecha030  = new Date(ev030.fecha);
              const diasHabil = 3;
              const fechaTacita = new Date(fecha030);
              fechaTacita.setDate(fechaTacita.getDate() + diasHabil);
              const hoy  = new Date();
              const diff = Math.ceil((fechaTacita - hoy) / 86400000);
              tacitaInfo = diff > 0 ? `En ${diff} día${diff !== 1 ? 's' : ''}` : 'Aplicable hoy';
            } else {
              tacitaInfo = 'Tras 3 días del acuse';
            }
          }

          const bg     = registrado ? ev.colorDone
                       : activo     ? ev.colorBase
                       : esTacita   ? '#1e293b'
                       : disponible ? ev.colorBase
                       : '#1a2535';
          const border = registrado ? ev.colorDone
                       : esTacita   ? '#334155'
                       : disponible ? ev.colorBase
                       : '#2d3f55';
          const opacity = esTacita ? 1 : (!registrado && !disponible) ? 0.45 : 1;

          return (
            <button key={cod}
              style={{ ...s.btnEvento, background: bg, borderColor: border, opacity,
                       boxShadow: activo ? `0 0 0 3px ${ev.colorBase}55` : 'none',
                       cursor: (registrado || esTacita) ? 'default' : disponible ? 'pointer' : 'not-allowed' }}
              onClick={() => {
                if (registrado || esTacita || !disponible) return;
                setAccion(activo ? null : cod);
                setResult(null);
              }}>
              <span style={s.btnEmoji}>{registrado ? '✓' : ev.emoji}</span>
              <span style={s.btnLabel}>{ev.nombre}</span>
              {registrado
                ? <span style={s.btnDone}>Registrado</span>
                : esTacita
                  ? <span style={{ ...s.btnDone, background:'rgba(255,255,255,.12)' }}>{tacitaInfo}</span>
                  : null
              }
              {esTacita && !registrado && (
                <span style={{ fontSize:8, color:'rgba(255,255,255,.5)', marginTop:2, lineHeight:1.2, textAlign:'center' }}>
                  Automática · DIAN
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* ── Alerta resultado ── */}
      {result && (
        <div style={{ ...s.alert,
          background: result.ok ? '#f0fdf4' : '#fef2f2',
          border:     `1px solid ${result.ok ? '#6ee7b7' : '#fca5a5'}`,
          color:      result.ok ? '#166534' : '#991b1b' }}>
          {result.ok ? '✅' : '❌'} {result.mensaje}
        </div>
      )}

      {/* ── Formulario de confirmación ── */}
      {accion && (
        <div style={{ ...s.formBox, borderColor: EVENTOS[accion].colorBase }}>
          <div style={{ fontWeight:700, color: EVENTOS[accion].colorBase, marginBottom:12, fontSize:14 }}>
            {EVENTOS[accion].emoji} Confirmar: {EVENTOS[accion].nombre}
          </div>

          <label style={s.label}>Su nombre completo *</label>
          <input style={s.input} placeholder="Nombre y apellido del responsable"
            value={form.nombre_firmante}
            onChange={e => setForm({ ...form, nombre_firmante: e.target.value })} />

          {accion === '031' && <>
            <label style={{ ...s.label, marginTop:12 }}>Motivo del reclamo *</label>
            <select style={s.input} value={form.motivo_codigo}
              onChange={e => setForm({ ...form, motivo_codigo: e.target.value })}>
              {MOTIVOS_031.map(m => <option key={m.codigo} value={m.codigo}>{m.codigo} — {m.desc}</option>)}
            </select>
            <label style={{ ...s.label, marginTop:12 }}>Descripción *</label>
            <textarea style={{ ...s.input, height:72, padding:'8px 12px', resize:'vertical' }}
              placeholder="Describa el motivo del reclamo..."
              value={form.motivo_desc}
              onChange={e => setForm({ ...form, motivo_desc: e.target.value })} />
          </>}

          <div style={{ display:'flex', gap:10, marginTop:14 }}>
            <button style={s.btnCancelar} onClick={() => setAccion(null)}>Cancelar</button>
            <button style={{ ...s.btnConfirmar, background: EVENTOS[accion].colorBase,
                             opacity: saving ? 0.7 : 1 }}
              onClick={handleRegistrar} disabled={saving}>
              {saving ? 'Registrando…' : `Confirmar — ${EVENTOS[accion].nombre}`}
            </button>
          </div>
        </div>
      )}

      {/* ── Datos de la factura ── */}
      <div style={s.card}>

        <div style={s.docHeader}>
          <div>
            <div style={s.docTipo}>FACTURA ELECTRÓNICA DE VENTA</div>
            <div style={s.docNum}>{f.numero}</div>
            <div style={s.docSub}>Fecha: {fmtF(f.fecha_emision)}</div>
            {f.fecha_vencimiento && <div style={s.docSub}>Vence: {fmtF(f.fecha_vencimiento)}</div>}
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={s.docSub}>Adquiriente</div>
            <div style={{ fontWeight:700, color:'#1e293b', fontSize:15 }}>{f.cliente_nombre}</div>
            <div style={s.docSub}>NIT: {f.nit}</div>
          </div>
        </div>

        {/* Items */}
        <table style={s.table}>
          <thead>
            <tr style={{ background:'#f1f5f9' }}>
              <th style={s.th}>Descripción</th>
              <th style={{ ...s.th, textAlign:'center' }}>Cant.</th>
              <th style={{ ...s.th, textAlign:'right' }}>Precio unit.</th>
              <th style={{ ...s.th, textAlign:'right' }}>IVA%</th>
              <th style={{ ...s.th, textAlign:'right' }}>Total</th>
            </tr>
          </thead>
          <tbody>
            {(f.items || []).map((it, i) => (
              <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#f8fafc' }}>
                <td style={s.td}>{it.descripcion}</td>
                <td style={{ ...s.td, textAlign:'center' }}>{it.cantidad} {it.unidad}</td>
                <td style={{ ...s.td, textAlign:'right' }}>{fmt(it.precio_unitario)}</td>
                <td style={{ ...s.td, textAlign:'center' }}>{it.iva_pct}%</td>
                <td style={{ ...s.td, textAlign:'right', fontWeight:600 }}>{fmt(it.total_item)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totales */}
        <div style={s.totalesWrap}>
          <div style={s.totalRow}><span>Subtotal</span><span>{fmt(f.subtotal)}</span></div>
          <div style={s.totalRow}><span>IVA</span><span>{fmt(f.iva)}</span></div>
          <div style={{ ...s.totalRow, ...s.totalFinal }}><span>TOTAL</span><span>{fmt(f.total)}</span></div>
        </div>

        {/* Condiciones */}
        <div style={s.infoRow}>
          <div style={s.infoBox}>
            <div style={s.infoLabel}>Forma de pago</div>
            <div style={s.infoVal}>{f.forma_pago === 'credito' ? 'Crédito' : 'Contado'}</div>
          </div>
          <div style={s.infoBox}>
            <div style={s.infoLabel}>Medio de pago</div>
            <div style={s.infoVal}>{f.medio_pago_desc || '—'}</div>
          </div>
          {f.referencia_oc && (
            <div style={s.infoBox}>
              <div style={s.infoLabel}>OC / Referencia</div>
              <div style={s.infoVal}>{f.referencia_oc}</div>
            </div>
          )}
        </div>

        {/* Historial de eventos registrados */}
        {(data?.eventos || []).length > 0 && (
          <div style={{ borderTop:'1px solid #f1f5f9', paddingTop:16, marginTop:8 }}>
            <div style={{ fontSize:12, fontWeight:700, color:'#64748b', textTransform:'uppercase',
                          letterSpacing:.8, marginBottom:10 }}>Eventos registrados</div>
            {data.eventos.map((ev, i) => {
              const meta = EVENTOS[ev.evento_codigo] || { colorDone:'#334155', bg:'#f8fafc', nombre: ev.evento_nombre, emoji:'📌' };
              return (
                <div key={i} style={{ display:'flex', gap:10, alignItems:'center', marginBottom:6,
                                      padding:'8px 12px', background: meta.bg, borderRadius:6,
                                      borderLeft:`3px solid ${meta.colorDone}` }}>
                  <span style={{ fontSize:16 }}>{meta.emoji}</span>
                  <div style={{ flex:1 }}>
                    <span style={{ fontWeight:600, color: meta.colorDone, fontSize:13 }}>
                      {ev.evento_codigo} — {ev.evento_nombre}
                    </span>
                    {ev.motivo_desc && <span style={{ color:'#64748b', fontSize:12 }}> · {ev.motivo_desc}</span>}
                  </div>
                  <span style={{ fontSize:11, color:'#94a3b8' }}>{fmtF(ev.fecha)}</span>
                </div>
              );
            })}
          </div>
        )}

      </div>

      <p style={{ textAlign:'center', color:'#94a3b8', fontSize:11, marginTop:16, marginBottom:32 }}>
        Factura electrónica validada por la DIAN · {f.empresa_nombre}
      </p>

    </div>
  );
}

const s = {
  page:        { minHeight:'100vh', background:'#f1f5f9', padding:'24px 16px', fontFamily:'Arial,sans-serif' },
  loadBox:     { maxWidth:480, margin:'80px auto', background:'#fff', borderRadius:16, padding:'40px 32px', boxShadow:'0 4px 24px rgba(0,0,0,.08)' },
  spinner:     { width:40, height:40, border:'4px solid #e2e8f0', borderTop:'4px solid #1e3a8a', borderRadius:'50%', animation:'spin 1s linear infinite', margin:'0 auto' },

  // Header empresa
  header:      { maxWidth:640, margin:'0 auto 0', textAlign:'center', background:'#1e3a8a', borderRadius:'12px 12px 0 0', padding:'20px 20px 16px' },
  headerNombre:{ fontSize:18, fontWeight:700, color:'#fff' },
  headerSub:   { fontSize:11, color:'rgba(255,255,255,.75)', marginTop:2 },

  // Botones RADIAN
  botonesWrap: { maxWidth:640, margin:'0 auto', background:'#0f172a', padding:'14px 16px',
                 display:'grid', gridTemplateColumns:'1fr 1fr 1fr 1fr 1fr', gap:8 },
  btnEvento:   { border:'2px solid', borderRadius:8, padding:'10px 6px', cursor:'pointer',
                 display:'flex', flexDirection:'column', alignItems:'center', gap:4,
                 transition:'all .2s', color:'#fff' },
  btnEmoji:    { fontSize:18 },
  btnLabel:    { fontSize:10, fontWeight:700, textAlign:'center', lineHeight:1.2 },
  btnDone:     { fontSize:9, background:'rgba(255,255,255,.25)', borderRadius:10,
                 padding:'2px 6px', marginTop:2 },

  // Alerta
  alert:       { maxWidth:640, margin:'8px auto', borderRadius:8, padding:'12px 16px',
                 fontSize:13, fontWeight:500 },

  // Formulario
  formBox:     { maxWidth:640, margin:'8px auto', background:'#fff', border:'2px solid',
                 borderRadius:10, padding:'16px 18px' },
  label:       { display:'block', fontSize:12, color:'#64748b', fontWeight:500, marginBottom:4 },
  input:       { width:'100%', padding:'0 12px', height:34, background:'#f8fafc',
                 border:'1px solid #e2e8f0', borderRadius:6, fontSize:13, color:'#1e293b',
                 boxSizing:'border-box', outline:'none' },
  btnCancelar: { flex:1, background:'#f1f5f9', border:'1px solid #e2e8f0', color:'#64748b',
                 borderRadius:6, padding:'9px 16px', fontSize:13, cursor:'pointer' },
  btnConfirmar:{ flex:2, color:'#fff', border:'none', borderRadius:6, padding:'9px 16px',
                 fontSize:13, fontWeight:600, cursor:'pointer' },

  // Card factura
  card:        { maxWidth:640, margin:'0 auto', background:'#fff', borderRadius:'0 0 12px 12px',
                 padding:'20px 20px 24px', boxShadow:'0 4px 24px rgba(0,0,0,.08)' },
  docHeader:   { display:'flex', justifyContent:'space-between', alignItems:'flex-start',
                 borderBottom:'2px solid #1e3a8a', paddingBottom:12, marginBottom:14 },
  docTipo:     { fontSize:9, fontWeight:700, color:'#64748b', textTransform:'uppercase', letterSpacing:1 },
  docNum:      { fontSize:22, fontWeight:700, color:'#1e3a8a', fontFamily:'monospace' },
  docSub:      { fontSize:12, color:'#64748b', marginTop:2 },
  table:       { width:'100%', borderCollapse:'collapse', fontSize:12, marginBottom:12 },
  th:          { padding:'7px 8px', color:'#64748b', fontWeight:600, fontSize:11,
                 textAlign:'left', borderBottom:'2px solid #e2e8f0' },
  td:          { padding:'7px 8px', borderBottom:'1px solid #f1f5f9', color:'#334155' },
  totalesWrap: { background:'#f8fafc', borderRadius:8, padding:'10px 14px', marginBottom:14 },
  totalRow:    { display:'flex', justifyContent:'space-between', color:'#64748b', fontSize:13, marginBottom:3 },
  totalFinal:  { color:'#1e293b', fontWeight:700, fontSize:15, borderTop:'1px solid #e2e8f0', paddingTop:7, marginTop:3 },
  infoRow:     { display:'flex', gap:8, flexWrap:'wrap' },
  infoBox:     { flex:1, minWidth:110, background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:6, padding:'7px 10px' },
  infoLabel:   { fontSize:10, color:'#94a3b8', textTransform:'uppercase', letterSpacing:.5 },
  infoVal:     { fontSize:13, fontWeight:600, color:'#1e293b', marginTop:2 },
};
